var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "inputWithLabel", class: { isPc: !_vm.isSp } },
      [
        !_vm.isVerifyCodeInPc
          ? _c(
              "InputLabel",
              {
                staticClass: "labelArea",
                class: {
                  isPc: !_vm.isSp,
                  isHasLabel: !_vm.isSp && (_vm.required || _vm.optional),
                  styleLabelWide: _vm.styleLabelWide,
                },
                attrs: {
                  required: _vm.required,
                  optional: _vm.optional,
                  "right-space": _vm.rightSpace,
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.areaLabel) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("InputItem", {
          staticClass: "inputItem",
          class: {
            hasError: _vm.hasError,
            isPc: !_vm.isSp,
            telNo: _vm.areaLabel === "電話番号",
            isLoginPage: _vm.isLoginPage,
          },
          attrs: {
            "input-type": _vm.inputType,
            "placeholder-value": _vm.placeholder,
            disabled: _vm.disabled,
            maxlength: _vm.maxlength,
          },
          on: {
            input: _vm.onInput,
            blur: _vm.onBlur,
            focus: function ($event) {
              return _vm.onFocus($event)
            },
          },
          model: {
            value: _vm.handleInputValue,
            callback: function ($$v) {
              _vm.handleInputValue = $$v
            },
            expression: "handleInputValue",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "underInputArea",
        class: {
          isPc: !_vm.isSp && !_vm.isVerifyCodeInPc,
          isNoLabel:
            !_vm.isSp &&
            !(_vm.required || _vm.optional) &&
            !_vm.isVerifyCodeInPc,
          styleLabelWide: _vm.styleLabelWide,
        },
      },
      [
        _c("PartialErrorMessage", {
          staticClass: "partialErrorComponent",
          attrs: { "is-sp-flg": true, error: _vm.displayError },
        }),
        _vm._v(" "),
        _vm.captionText
          ? _c(
              "CaptionText",
              {
                staticClass: "captionText",
                class: { hasError: _vm.hasError, isPc: !_vm.isSp },
              },
              [_vm._v("\n      " + _vm._s(_vm.captionText) + "\n    ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }